var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#19336A",
  fillRule: "evenodd",
  stroke: "#19336A",
  strokeLinecap: "round",
  d: "m6.055 6.903-4.88-4.879a.6.6 0 0 1 .85-.848l4.878 4.879 4.88-4.88a.6.6 0 0 1 .848.85L7.75 6.902l4.88 4.88a.6.6 0 1 1-.849.848L6.903 7.75l-4.879 4.88a.6.6 0 1 1-.848-.849l4.879-4.879z"
})));
export default SvgClose;